export default class BoardType {
  label?: string;
  ordinal?: number;

  constructor(label: string, ordinal: number) {
    this.label = label;
    this.ordinal = ordinal;
  }
}

export const BoardTypesChoices = {
  WOOD: new BoardType('Hout', 0),
  ALUMINIUM: new BoardType('Aluminium', 1)
};

export const BoardTypesChoiceArray = Object.values(BoardTypesChoices);
